<template>
  <b-tabs content-class="mt-3">
    <b-tab title="Team Colors">
      <team-colors-form
        :key="componentKey"
        v-model="config"
        :selected-team="selectedTeam" />
    </b-tab>
    <b-tab title="Cap Logos">
      <cap-logos-form
        :key="componentKey"
        v-model="selectedTeam" />
    </b-tab>
    <b-tab title="Wordmarks">
      <wordmarks-form
        :key="componentKey"
        v-model="selectedTeam" />
    </b-tab>
    <b-tab title="MLB.tv">
      <mlb-tv-form
        :key="componentKey"
        v-model="selectedTeam" />
    </b-tab>
  </b-tabs>
</template>

<script>
  import TeamColorsForm from "@/components/Branding/TeamColorsForm"
  import CapLogosForm from "@/components/Branding/CapLogosForm"
  import WordmarksForm from "@/components/Branding/WordmarksForm"
  import MlbTvForm from "@/components/Branding/MlbTvForm"

  export default {
    name: "TeamTabs",
    components: {
      MlbTvForm,
      WordmarksForm,
      CapLogosForm,
      TeamColorsForm,
    },
    props: {
      value: {
        type: Object,
        required: true,
      },
      selectedTeam: {
        type: Object,
        required: true,
      },
      componentKey: {
        type: Number,
        required: true,
      },
    },
    computed: {
      config: {
        get: function () {
          return this.value
        },
        set: function (value) {
          this.$emit("input", value)
        },
      },
    },
  }
</script>

<style scoped>

</style>
